import React from 'react';
import { Redirect } from 'react-router';

export default function HomePage() {
  return <Redirect to="/cosmos" />;
}
